import React from "react";
import { ArrowUp, Camera } from "lucide-react";
import DefaultMessages from "./queries/DefaultMessages";
import useImagePicker from "./useImagePicker";

// Start-of-chat panel: optional brand welcome image + text, quick-reply cards, and "Upload a photo" / "Take a photo" cards.
function WelcomePanel({ welcomeImage, welcomeText, actionButtons, isLoading, setIsLoading, imageUploadEnabled, onImageSelected }) {
  const { openGalleryPicker, openCamera, pickerElements } = useImagePicker(onImageSelected);
  const hasActionButtons = actionButtons && typeof actionButtons === "object" && Object.keys(actionButtons).length > 0;

  return (
    <div className="krunk-flex krunk-flex-col krunk-gap-3 krunk-px-5 krunk-pt-2 krunk-pb-4">
      {welcomeImage && (
        <img src={welcomeImage} alt="" className="krunk-mx-auto krunk-max-h-40 krunk-object-contain" />
      )}

      {welcomeText && (
        <p className="krunk-text-center krunk-text-lg krunk-font-medium krunk-leading-snug krunk-text-buttonbackground krunk-px-2 krunk-mb-1">
          {welcomeText}
        </p>
      )}

      {hasActionButtons && (
        <DefaultMessages isLoading={isLoading} setIsLoading={setIsLoading} actionButtons={actionButtons} />
      )}

      {imageUploadEnabled && (
        <div className="krunk-grid krunk-grid-cols-2 krunk-gap-3">
          <PhotoOptionCard label="Upload a photo" Icon={ArrowUp} onClick={openGalleryPicker} disabled={isLoading} />
          <PhotoOptionCard label="Take a photo" Icon={Camera} onClick={openCamera} disabled={isLoading} />
        </div>
      )}

      {pickerElements}
    </div>
  );
}

// Large tappable card with a label and a round accent-colored icon, used for the photo options.
function PhotoOptionCard({ label, Icon, onClick, disabled }) {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      className="krunk-flex krunk-flex-col krunk-items-center krunk-justify-center krunk-gap-3 krunk-py-6 krunk-rounded-3xl krunk-bg-white/80 krunk-shadow-sm krunk-border krunk-border-gray-100 krunk-text-base krunk-text-black krunk-transition hover:krunk-shadow-md disabled:krunk-opacity-50"
    >
      <span>{label}</span>
      <span className="krunk-flex krunk-items-center krunk-justify-center krunk-w-10 krunk-h-10 krunk-rounded-full krunk-bg-buttonbackground krunk-text-white">
        <Icon className="krunk-w-5 krunk-h-5" />
      </span>
    </button>
  );
}

export default WelcomePanel;
